module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/cybermonday-productos-desktop.1ffd3cc3.png";